<template>
  <div style="background: #fff">
    <!-- 头部信息区 -->
    <div class="info-wrap">
      <div class="info_head">
        <img :src="userinfo.thumbAvatar" class="avatar" alt="" />
        <div class="info_personal">
          <div class="info_nickName">{{ userinfo.nickName }}</div>
          <div class="info_position" v-if="userinfo.position">{{ userinfo.position }}</div>
        </div>
      </div>
      <van-row class="info_nav">
        <van-col span="7">
          <span class="number">{{form.inCompanyYear}}</span>
          <span class="type">工龄(年)</span>
        </van-col>
        <van-col span="1"></van-col>
        <van-col span="7">
          <span class="number">{{form.score}}</span>
          <span class="type">我的积分</span>
        </van-col>
        <van-col span="1"></van-col>
        <van-col span="7">
          <span class="number">{{form.birthdayCount}}</span>
          <span class="type">生日到计时(天)</span>
        </van-col>
      </van-row>
      <van-tabbar v-model="active" :fixed="false" route>
        <van-tabbar-item to="/shezhi/notice">
          <span>通知公告</span>
          <template #icon="props">
            <img src="../../assets/images/desktop/tzgg.png" :alt="props.active?'':''" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item :to="'/shezhi/details?verifyStatus=' + form.verifyStatus">
          <span>个人档案</span>
          <template #icon="props">
            <img :src="isExamine?require('../../assets/images/desktop/grda01.png'):require('../../assets/images/desktop/grda02.png')" :alt="props.active?'':''" />
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/admi/salary/mysalary">
          <span>我的工资</span>
          <template #icon="props">
            <img src="../../assets/images/desktop/wdgz.png" :alt="props.active?'':''" />
          </template>
        </van-tabbar-item>
      </van-tabbar>
    </div>
    <div class="list">
    <!-- <van-list v-model="noticeLoading" :finished="noticeFinished"  finished-text="没有更多了" @load="noticeOnLoad" v-if="noticeList.length > 0"> -->
      <van-cell v-for="(item, index) in noticeList" :key="index" @click="toDetails(item)">
        <div class="main_box">
          <img src="../../assets/images/desktop/tz.png" alt="">
          <div class="right_detail">
            <div class="name_wrap">{{item.noticeTitle}} <span>{{item.createTime}}</span></div>
            <div class="content" v-html="item.noticeContent.replace('<p>','')"></div>
            <div class="bottom">
              <span>详情</span><van-icon color="#c1c1c1" name="arrow" size="12" />
            </div>
          </div>
        </div>
      </van-cell>
    </div>
    <!-- </van-list> -->
    <empty-component v-if="noticeEmpty" />
  </div>
</template>

<script>

import { Toast, Tabbar, TabbarItem } from 'vant'
import EmptyComponent from '@/components/common/Empty'

import { getUserProfileInfor, listNotice } from '@/api/admi/user'
import { mapGetters } from 'vuex'
// import { resetUserPwd } from '@/api/system/user'
// import { listArchives } from '@/api/admi/ps_archives'
import { getDicts } from '@/api/system/dict/data'

export default {
  name: 'ShezhiIndex',
  components: {
    [Toast.name]: Toast,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    EmptyComponent
    // ActionSheet
  },
  computed: {
    ...mapGetters({
      userinfo: 'userinfo'
    })
    // sex() {
    //   return this.selectDictLabel(this.options.sexOptions, this.form.sex)
    // },
    // isMarriage() {
    //   return this.selectDictLabel(this.options.isMarriageOptions, this.form.isMarriage)
    // },
    // nativePlace() {
    //   return this.selectDictLabel(this.options.nativePlaceOptions, this.form.nativePlace)
    // },
    // education() {
    //   return this.selectDictLabel(this.options.educationOptions, this.form.education)
    // }
  },
  props: {},
  data() {
    return {
      active: 0,
      noticeList: [],
      noticeQuery: {
        pageNum: 1,
        pageSize: 10,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      noticeEmpty: false,
      isExamine: false, // 数据是否审核，表单是否可操作
      // userProfileInfor: {},// 用户档案信息
      form: {},
      sytime: '', // 使用时间
      options: {

      }
    }
  },
  watch: {},
  async created() {
    this.getOptions()
    await this.getUserProfileInfor()
    console.log('userinfo', this.userinfo)
    this.getNoticeList()
  },
  mounted() {
    this.getDicts('native_place').then(response => {
      this.claimStatusOptions = response.data
    })

    this.init()
    // this.listArchives();
  },
  methods: {

    Native(type) {
      // console.log("test:" + JSON.stringify( this.options));
      if (type === 'nativePlace') {
        this.picker.formKey = type
        this.picker.columns = this.nativePlaceOptions.map((ele) => ele.dictLabel)
      }
    },
    getOptions() {
      // 籍贯
      getDicts('native_place').then(res => {
        this.options.nativePlaceOptions = res.data
      })
      // 学历
      getDicts('sys_education').then(res => {
        this.options.educationOptions = res.data
      })
      // 性别
      getDicts('sys_user_sex').then(res => {
        this.options.sexOptions = res.data
      })
      // 婚姻状况
      getDicts('admi_marriage_type').then(res => {
        this.options.isMarriageOptions = res.data
      })
    },
    // 获取用户档案信息
    async getUserProfileInfor() {
      const res = await getUserProfileInfor(this.userinfo.userId)
      if (res.code === 200) {
        // this.userProfileInfor = res.data
        if (res.data) {
          this.form = res.data
          this.sytime = res.data.trialStartTime + res.data.trialEndTime
          if (res.data.verifyStatus === '1') {
            this.isExamine = true
          }
          // else if (res.data.verifyStatus === '2') {
          //   Toast.fail('审核不通过，请重新输入并提交')
          // }
        }
      }
    },
    async init() {
      // 修改主体框架标题
      document.title = '我的'
    },
    async getNoticeList() {
      const res = await listNotice(this.noticeQuery)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.noticeEmpty = true
        } else {
          this.noticeEmpty = false
          this.noticeList = res.rows.slice(0, 3)
        }
      }
    },
    toDetails(item) {
      this.$router.push({
        path: '/shezhi/noticeDetail',
        query: { noticeId: item.noticeId }
      })
    }
  }
}
</script>

<style scoped lang='less'>
@import url("@/style/index.less");

.info-wrap {
  z-index: 10;
  position: fixed;
  top: 0;
  width: 100%;
  height: 300px;
  background: linear-gradient(90deg, #1890ff 0%, #4d74f5 26%, #2cb5e8 75%);
  color: white;
  opacity: 0.95;
  padding: 40px;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  .info_head{
    display: flex;
    align-items: center;
    .avatar {
      width: 120px;
      height: 120px;
      border-radius: 50%;
    }
    .info_personal{
      margin-left: 40px;
      .info_nickName{
        font-size: 40px;
        // margin-top: 40px;
        font-weight: 500;
      }
      .info_position{
        font-size: 26px;
        color: #e4e4e4;
        padding: 14px 40px;
        margin-top: 20px;
        border: 1px #c4c4c4 solid;
        border-radius: 999px;
      }
    }
  }
  .info_nav{
    margin-top: 20px;
    display: flex;
    align-items: center;
    /deep/.van-col{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      height: 90px;
      .number{
        font-size: 32px;
        color: #fff;
      }
      .type{
        font-size: 28px;
        color: #e4e4e4;
      }
    }
    /deep/.van-col--1{
      background-color: #fff;
      height: 60px;
      width: 1px;
    }
  }
  /deep/ .van-tabbar{
    height: 160px;
    width: 90%;
    margin-top: 20px;
    background-color: #fff;
    border-radius: 10px;
    box-shadow:0 0 20px #87CEFA;
    .van-tabbar-item__icon{
      img{
        width: 80px;
        height: 80px;
      }
    }
    .van-tabbar-item__text{
      font-size: 30px;
      margin-top: 8px;
    }
    .van-tabbar-item--active{
      border-radius: 10px;

      .van-tabbar-item__text{
        color: #333;
      }
    }
  }
}
// /deep/.van-list{
.list{
  padding-top: 460px;
  .main_box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 30px;
    .right_detail{
      margin-left: 20px;
      position: relative;
      .name_wrap{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 30px;
        font-weight: bold;
        span{
          font-size: 26px;
          font-weight: 400;
          color: #666;
        }
      }
      .content{
        font-size: 28px;
        color: #999;
      }
      .bottom{
        position: absolute;
        bottom: -40px;
        right: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        span{
          margin-right: 10px;
          color: #c4c4c4;
        }
      }
    }
  }
}

</style>
